var map = {
	"./": "7b3a",
	"./development": "2193",
	"./development.js": "2193",
	"./fat": "e279",
	"./fat.js": "e279",
	"./index": "7b3a",
	"./index.js": "7b3a",
	"./production": "e37b",
	"./production.js": "e37b",
	"./uat": "0cdf",
	"./uat.js": "0cdf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "371d";